import React from 'react';
import SetupHostedNumberDialogView from './SetupHostedNumberDialogView';
import { useSetupHostedNumberDialogController } from '../../../controllers';
import { SetupHostedNumberDialogProps } from '../../../types';

const SetupHostedNumberDialog = (props: SetupHostedNumberDialogProps) => {
  const viewModel = useSetupHostedNumberDialogController(props);
  return <SetupHostedNumberDialogView {...viewModel} />;
};

export default SetupHostedNumberDialog;
